"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultUnsubscribeTranslate = void 0;
exports.defaultUnsubscribeTranslate = {
    title: 'Notifications',
    caption: 'Manage notifications you receive from OKAY.com',
    all: 'All Notifications',
    savedSearch: 'Notifications from your Saved Searches',
    place: 'Update from your following places',
    newsletterTitle: 'Communications & Other marketings from OKAY.com',
    newsletterCaption: 'Property Updates & Our property flyers',
    receive: 'Receive',
    receiveAll: 'Receive All',
    save: 'Save',
    deletePopupTitle: 'Too Many Notifications?',
    deletePopupCaption: 'We are sorry to hear that you wish to delete your account. If it’s because you’re are receiving too many emails, please click <b>Unsubscribe</b> to stop notification completely.',
    deletePopupDelete: 'Delete my account',
    deletePopupCancel: 'Unsubscribe',
    confirmTitle: 'Account Deletion',
    confirmCaption: 'This action cannot be reversed! Are you sure to delete?',
    confirmDownload: 'Download my data before deletion',
    confirmCancel: 'Cancel',
    confirmDelete: 'Delete',
};
